// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const fileUploadClasses = {
  addMoreButton: "qui-file-upload__add-more-button",
  clearTrigger: "qui-file-upload__clear-trigger",
  dropzone: "qui-file-upload__dropzone",
  dropzoneHint: "qui-file-upload__dropzone-hint",
  dropzoneIcon: "qui-file-upload__dropzone-icon",
  dropzoneText: "qui-file-upload__dropzone-text",
  dropzoneTextGroup: "qui-file-upload__dropzone-text-group",
  dropzoneTextLine: "qui-file-upload__dropzone-text-line",
  errorText: "qui-file-upload__error-text",
  inputDisplay: "qui-file-upload__input-display",
  item: "qui-file-upload__item",
  itemClearIcon: "qui-file-upload__item-clear-icon",
  itemContent: "qui-file-upload__item-content",
  itemDeleteTrigger: "qui-file-upload__item-delete-trigger",
  itemGroup: "qui-file-upload__item-group",
  itemName: "qui-file-upload__item-name",
  itemPreview: "qui-file-upload__item-preview",
  itemPreviewImage: "qui-file-upload__item-preview-image",
  itemSizeText: "qui-file-upload__item-size-text",
  label: "qui-file-upload__label",
  requiredIndicator: "qui-file-upload__required-indicator",
  root: "qui-file-upload__root",
  trigger: "qui-file-upload__trigger",
} as const
